module.exports = __webpack_public_path__ + "static/media/botTakeover.0a9d4503.png";